document.addEventListener('DOMContentLoaded', function () {
  // =========================================
  // 2) Consentmo a11y for custom trigger button
  //    (footer "Cookie Preferences")
  // =========================================
  let lastPreferencesTrigger = null;

  function returnFocusToTrigger() {
    if (lastPreferencesTrigger && document.body.contains(lastPreferencesTrigger)) {
      try {
        lastPreferencesTrigger.focus();
      } catch (e) {
        //console.warn('Unable to return focus to cookie preferences trigger:', e);
      }
    }
  }

  document.addEventListener('click', function (event) {
    const footerTrigger = event.target.closest('.isense-reopen-widget-link');
    if (footerTrigger) {
      lastPreferencesTrigger = footerTrigger;
    }
  });

  document.addEventListener('click', function (event) {
    const actionBtn = event.target.closest(
      '.cc-btn-close-settings, .isense-cc-btn-accept-selected, .isense-cc-btn-accept-all'
    );
    if (!actionBtn) return;
    setTimeout(returnFocusToTrigger, 0);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (!lastPreferencesTrigger) return;

    const dialog = document.querySelector('.isense-cc-window');
    if (!dialog) return;

    const isHidden =
      dialog.getAttribute('aria-hidden') === 'true' ||
      dialog.style.display === 'none';

    if (!isHidden) {
      setTimeout(returnFocusToTrigger, 20);
    }
  });

  // =========================================
  // 3) Consentmo: adjust policy link in cookie banner
  // =========================================
  function initLinkObserver(wrapper) {
    if (!wrapper) return;
    if (!('MutationObserver' in window)) return;

    let hasCleanedLink = false;

    function cleanConsentmoLinks(root) {
      const scope = root || document;
      const links = [];

      if (scope.matches && scope.matches('a.isense-cc-link')) {
        links.push(scope);
      }

      if (scope.querySelectorAll) {
        scope.querySelectorAll('a.isense-cc-link').forEach(function (link) {
          if (links.indexOf(link) === -1) {
            links.push(link);
          }
        });
      }

      if (!links.length) return;

      hasCleanedLink = true;

      links.forEach(function (link) {
        if (link.hasAttribute('target')) {
          link.removeAttribute('target');
        }
        if (link.hasAttribute('aria-label')) {
          link.removeAttribute('aria-label');
        }
      });
    }

    // Clean anything already present
    cleanConsentmoLinks(wrapper);

    const linkObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (node.matches && node.matches('a.isense-cc-link')) {
            cleanConsentmoLinks(node);
          } else if (node.querySelectorAll) {
            cleanConsentmoLinks(node);
          }
        });
      });

      // Once we've cleaned at least one link and there are no more,
      // disconnect observer for this user session.
      if (hasCleanedLink && !wrapper.querySelector('a.isense-cc-link')) {
        linkObserver.disconnect();
      }
    });

    linkObserver.observe(wrapper, {
      childList: true,
      subtree: true
    });
  }

  let wrapper = document.getElementById('csm-wrapper');
  if (wrapper) {
    initLinkObserver(wrapper);
  } else if ('MutationObserver' in window) {
    const bodyObserver = new MutationObserver(function (mutations, observer) {
      wrapper = document.getElementById('csm-wrapper');
      if (wrapper) {
        observer.disconnect();
        initLinkObserver(wrapper);
      }
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });

    setTimeout(function () {
      bodyObserver.disconnect();
      wrapper = document.getElementById('csm-wrapper');
      if (wrapper) {
        initLinkObserver(wrapper);
      }
    }, 10000);
  }
});

// =========================================
// 4) Consentmo banner (current version: drawn inside <csm-cookie-consent>,
//    an open shadow root). Styles for the classes added here live in
//    Consentmo > Design > Custom CSS.
//    - Heading: the first line of the banner text (before a line break), or
//      the text up to the first full stop when it starts with one of HEADINGS.
//      Shown with a cookie icon; it also names the banner for screen readers.
//    - "Learn more" link gets a full name for screen readers.
//    - US banner (has "Do not sell or share…"): the main button reads "Got it",
//      and the opt-out button is moved after it and shown as an underlined
//      link (CSS). Other regions keep Consentmo's labels.
//    - When the banner first shows (and the page has finished loading), focus goes
//      to its heading, so screen readers start reading the banner. Skipped if the
//      visitor has already clicked, tapped or pressed a key, or focused something.
//    - After the banner is answered (any button, any region), focus goes to the
//      page itself (body), so keyboard and screen reader users start again from
//      the top instead of landing on whatever sits next to the banner.
// =========================================
(function () {
  // Headings to recognise when the text field keeps no line break
  var HEADINGS = [
    'Cookies that make shopping easier',
    'We use cookies to make shopping easier',
    'Cookies for a better shopping experience'
  ];
  var LEARN_RE = /^learn more\.?$/i;
  var LEARN_LABEL = 'Learn more about how we use cookies (opens in a new tab)';
  var OPTOUT_RE = /^do not sell or share/i;
  // US banner only (the one with "Do not sell or share"): the accept button is a
  // notice there, not a consent, so it reads "Got it". Other regions keep the
  // app's label (e.g. "Accept all" next to "Reject all" in the EU).
  var US_ACCEPT_LABEL = 'Got it';
  var ICON = '<svg aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.5A9 9 0 1 1 11.5 3a3 3 0 0 0 3.5 3.5 3 3 0 0 0 3.5 3.5 3 3 0 0 0 2.5 2.5z"/><path d="M8.5 9.5h.01M15.5 15.5h.01M10 15h.01M12 12h.01"/></svg>';

  function splitTitle(full) {
    var cut = full.indexOf('\n');
    if (cut > 0) return { title: full.slice(0, cut), rest: full.slice(cut + 1) };
    var t = full.trim();
    for (var i = 0; i < HEADINGS.length; i++) {
      if (t.toLowerCase().indexOf(HEADINGS[i].toLowerCase()) === 0) {
        return { title: t.slice(0, HEADINGS[i].length), rest: t.slice(HEADINGS[i].length).replace(/^[.:!\s]+/, '') };
      }
    }
    return null;
  }

  function enhance(root) {
    var region = root.querySelector('[role="region"]');
    var desc = root.querySelector('#cookieconsent-desc');
    var textEl = root.querySelector('#isense-cc-cookie-bar-text');

    // Heading (with icon) from the start of the banner text
    if (region && desc && textEl) {
      var parts = splitTitle(textEl.textContent || '');
      if (parts) {
        var title = parts.title.trim().replace(/\.$/, '');
        var rest = parts.rest.trim();
        if (title) {
          var heading = root.querySelector('.tpw-cc-title');
          if (!heading) {
            heading = document.createElement('h2');
            heading.className = 'tpw-cc-title';
            heading.id = 'tpw-cc-title';
            heading.innerHTML = ICON + '<span class="tpw-cc-title-text"></span>';
            desc.parentNode.insertBefore(heading, desc);
          }
          var titleText = heading.querySelector('.tpw-cc-title-text');
          if (titleText.textContent !== title) titleText.textContent = title;
          textEl.textContent = rest + ' ';
          if (region.getAttribute('aria-labelledby') !== heading.id) region.setAttribute('aria-labelledby', heading.id);
        }
      }
    }

    // "Learn more" link: full name for screen readers (visible text unchanged)
    var links = root.querySelectorAll('a.cc-link');
    for (var i = 0; i < links.length; i++) {
      if (LEARN_RE.test(links[i].textContent.trim()) && links[i].getAttribute('aria-label') !== LEARN_LABEL) {
        links[i].setAttribute('aria-label', LEARN_LABEL);
      }
    }

    // US opt-out button -> link style (CSS) under the main button. It is moved
    // after the main button in the DOM too, so screen readers and Tab follow
    // the same order people see (Consentmo puts it first).
    var btns = root.querySelectorAll('.cc-compliance .cc-btn');
    for (var j = 0; j < btns.length; j++) {
      if (!OPTOUT_RE.test(btns[j].textContent.trim())) continue;
      var optout = btns[j];
      var group = optout.closest('.cc-compliance');
      if (!optout.classList.contains('tpw-cc-optout')) optout.classList.add('tpw-cc-optout');
      if (group) {
        if (!group.classList.contains('tpw-cc-us')) group.classList.add('tpw-cc-us');
        if (group.lastElementChild !== optout) group.appendChild(optout);
        var accept = group.querySelector('.cc-allow');
        var acceptText = accept && (accept.querySelector('.csm-arp-btn-text') || accept);
        if (acceptText && acceptText.textContent.trim() !== US_ACCEPT_LABEL) {
          acceptText.textContent = US_ACCEPT_LABEL;
          if (acceptText.hasAttribute('data-text')) acceptText.setAttribute('data-text', US_ACCEPT_LABEL);
        }
      }
    }
  }

  function shown(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  // Banner answered: nothing of it is left on screen (preferences panel included).
  function bannerGone(root) {
    if (shown(root.querySelector('[role="region"]'))) return false;
    var panels = root.querySelectorAll('.cc-settings-dialog, .isense-cc-settings-dialog, .csm-tcf-popup');
    for (var i = 0; i < panels.length; i++) { if (shown(panels[i])) return false; }
    return true;
  }

  // Visitor already doing something: don't pull focus to the banner.
  var userActed = false;
  ['keydown', 'pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function () { userActed = true; }, { capture: true, once: true });
  });

  // Consentmo focuses the banner text while the page may still be loading; a screen
  // reader can then jump back to the top when loading ends. Focus the heading once
  // loading is done so the banner is what gets read first.
  var bannerFocused = false;
  function focusBanner(host, root) {
    if (bannerFocused) return;
    var region = root.querySelector('[role="region"]');
    if (!shown(region)) return;
    bannerFocused = true;
    function go() {
      setTimeout(function () {
        if (userActed || !region.isConnected || !shown(region)) return;
        var a = document.activeElement;
        if (a && a !== document.body && a !== host) return;
        var target = root.querySelector('#tpw-cc-title') || root.querySelector('#isense-cc-cookie-bar-text');
        if (!target || root.activeElement === target) return;
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        // A heading, not a control: no focus ring. Set as !important inline so Consentmo's own
        // ":focus" outline rules (also !important) can't put a ring back on it.
        target.style.setProperty('outline', 'none', 'important');
        target.style.setProperty('box-shadow', 'none', 'important');
        target.focus({ preventScroll: true });
      }, 400);
    }
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go, { once: true });
  }

  function focusPage(host, root) {
    if (!bannerGone(root)) return;
    var a = document.activeElement;
    if (a && a !== document.body && a !== host) return; // focus already moved somewhere else
    if (root.activeElement && shown(root.activeElement)) return;
    var body = document.body;
    body.setAttribute('tabindex', '-1');
    body.style.outline = 'none';
    body.focus({ preventScroll: true });
    body.addEventListener('blur', function () {
      body.removeAttribute('tabindex');
      body.style.outline = '';
      if (body.getAttribute('style') === '') body.removeAttribute('style');
    }, { once: true });
  }

  function watch() {
    var host = document.querySelector('csm-cookie-consent');
    var root = host && host.shadowRoot;
    if (!root) return false;
    enhance(root);
    focusBanner(host, root);
    root.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('button') : null;
      if (!btn) return;
      // Consentmo removes the banner right after the click (sometimes with a short animation).
      setTimeout(function () { focusPage(host, root); }, 120);
      setTimeout(function () { focusPage(host, root); }, 600);
    });
    new MutationObserver(function () { enhance(root); focusBanner(host, root); }).observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-label', 'class']
    });
    return true;
  }

  function start() {
    if (watch()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (watch() || ++tries > 40) clearInterval(timer); // up to 10 s for the banner
    }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();